import React from 'react'
import USTemplateDefault from 'src/components/template/us'
export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    video={'https://assets.fubo.tv/marketing/lp/videos/compressed/Grammys_2022_LP_12sec_V3.mp4'}
    title="Watch the GRAMMYs on CBS"
    subtitle="See Music's Biggest Night® live"
    ctaText={'Start Watching'}
  />
)
